import http from '@/services/http'

const initialErrors = {
  email: [],
}

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    owners: [],
    saveInProgress: false,
    removeInProgress: false,
    errors: initialErrors,
  },
  mutations: {
    START_FETCH(state) {
      state.fetchInProgress = true
    },
    SET_OWNER_LIST_DATA(state, owners) {
      state.owners = owners
    },
    SET_ERRORS(state, errors) {
      state.errors = errors
    },
    STOP_FETCH(state) {
      state.fetchInProgress = false
    },

    START_SAVE(state) {
      state.saveInProgress = true
    },
    STOP_SAVE(state) {
      state.saveInProgress = false
    },

    START_REMOVE(state) {
      state.removeInProgress = true
    },
    STOP_REMOVE(state) {
      state.removeInProgress = false
    },
    REMOVE_OWNER(state, userId) {
      state.owners = state.owners.filter((o) => o.user_id !== userId)
    },
  },
  actions: {
    async fetch({ commit, state }, { orgId }) {
      commit('START_FETCH')
      const response = await http.getAuthed(`/organizations/${orgId}/users`)
      commit('SET_OWNER_LIST_DATA', response.data)
      commit('STOP_FETCH')
    },
    async create({ commit, state }, { email, orgId }) {
      commit('START_SAVE')
      try {
        const response = await http.postAuthed(
          `/organizations/${orgId}/add-user`,
          { email },
        )
        return response.data
      } catch (error) {
        if (error.response) {
          commit('SET_ERRORS', error.response.data)
        }
        throw error
      } finally {
        commit('STOP_SAVE')
      }
    },
    async remove({ commit, state }, { userId, orgId }) {
      commit('START_REMOVE')
      const response = http.postAuthed(`/organizations/${orgId}/remove-user`, {
        user_id: userId,
      })
      try {
        await response
      } finally {
        commit('STOP_REMOVE')
      }
      commit('REMOVE_OWNER', userId)
    },
  },
}
